import './MedicalRecordSharedDocument.scss';
import CardComponent from "../../../shared/components/card/CardComponent";
import TableWrapperComponent from "../../../shared/components/table-wrapper/TableWrapperComponent";
import {APIConfig} from "../../../constants";
import {ITableColumn} from "../../../shared/models/table.model";
import {CommonService} from "../../../shared/services";
import moment from "moment-timezone";
import {useCallback, useState} from "react";
import momentTimezone from "moment-timezone";
import LinkComponent from "../../../shared/components/link/LinkComponent";
import SelectDropdownComponent from "../../../shared/components/form-controls/select-dropdown/SelectDropdownComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import DateRangePickerComponentV2 from "../../../shared/components/date-range-pickerV2/DateRangePickerComponentV2";

interface MedicalRecordSharedDocumentProps {
    caseId: string;
}

const MedicalRecordSharedDocument = (props: MedicalRecordSharedDocumentProps) => {
    const {caseId} = props;

    const [medicalRecordFilterState, setMedicalRecordFilterState] = useState<any>({
        timezone: momentTimezone.tz.guess(),
        file_type: undefined,
        date_range: [null, null],
        start_date: null,
        end_date: null,
        sort: {}
    });
    const {
        documentTypeList,
        isDocumentTypeListLoading,
        isDocumentTypeListLoaded,
    } = useSelector((state: IRootReducerState) => state.staticData);

    const columns: ITableColumn[] = [
        {
            title: 'Document Date',
            key: 'document_date',
            dataIndex: 'document_date',
            render: (record: any) => {
                return <>
                    {
                        CommonService.getDateFromTimezone(record?.document_date || record?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')
                    }</>
            }
        },
        {
            title: 'Document Type',
            key: 'document_type',
            dataIndex: 'document_type',
            align: 'center',
            render: (record: any) => {
                return <>
                    {
                        record?.file_type
                    }</>
            }
        },
        {
            title: 'Provider Name',
            key: 'provider',
            dataIndex: 'provider',
            sortable: true,
            render: (record: any) => {
                return <>
                    {
                        record?.provider_details?.first_name + ' ' + record?.provider_details?.last_name
                    }</>
            }
        },
        {
            title: 'Action',
            key: 'action',
            fixed: 'right',
            align: 'center',
            render: (record: any) => {
                return <>
                    <LinkComponent>
                        View/Download
                    </LinkComponent>
                </>
            }
        }
    ];

    const handleSort = useCallback((key: string, order: string) => {
        setMedicalRecordFilterState((oldState: any) => {
            const newState = {...oldState};
            newState["sort"] = {
                key,
                order
            }
            return newState;
        })
    }, []);


    return (
        <div className="medical-record-shared-document">
            <CardComponent>
                <div className={'filter-wrapper'}>
                    <div className={'ts-row'}>
                        <div className={'ts-col-lg-3 shared-document-heading'}>
                            Shared Documents
                        </div>
                        <div className={'ts-col-lg-4'}/>
                        <div className={'ts-col-lg-2'}>
                            <SelectDropdownComponent
                                size={"small"}
                                fullWidth={true}
                                placeholder={"Document Type"}
                                options={documentTypeList}
                                value={medicalRecordFilterState.file_type}
                                displayWith={(option: any) => option.type}
                                valueExtractor={(option: any) => option.type}
                                isClearable={true}
                                isDataLoading={isDocumentTypeListLoading}
                                isDataLoaded={isDocumentTypeListLoaded}
                                onUpdate={(value: any) => {
                                    setMedicalRecordFilterState({
                                        ...medicalRecordFilterState,
                                        file_type: value
                                    });
                                }}
                            />
                        </div>
                        <div className={'ts-col-lg-3'}>
                            <DateRangePickerComponentV2
                                value={medicalRecordFilterState?.date_range}
                                onDateChange={(value: any) => {
                                    setMedicalRecordFilterState((prevState: any) => {
                                        if (value) {
                                            return {
                                                ...prevState,
                                                start_date: moment(value[0]).format('YYYY-MM-DD'),
                                                end_date: moment(value[1]).format('YYYY-MM-DD'),
                                                date_range: value,
                                                timezone: momentTimezone.tz.guess()
                                            };
                                        } else {
                                            const {date_range, start_date, end_date, ...rest} = prevState;
                                            return rest;
                                        }
                                    });
                                }}
                            />
                        </div>
                    </div>
                </div>
                <TableWrapperComponent url={APIConfig.GET_MEDICAL_RECORD_SHARED_DOCUMENTS_LIST.URL(caseId)}
                                       method={APIConfig.GET_MEDICAL_RECORD_SHARED_DOCUMENTS_LIST.METHOD}
                                       extraPayload={medicalRecordFilterState}
                                       onSort={handleSort}
                                       noDataText={'No documents have been shared.'}
                                       columns={columns}/>
            </CardComponent>
        </div>
    )
}

export default MedicalRecordSharedDocument;
